import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import "@fontsource-variable/roboto-mono";
import "@/styles/globals.css";

import { DEFAULT_LOCALE } from "@/shared/i18n";
import { loadDictionary } from "@/shared/i18n/dictionary-loader";
import { readLocaleCookie } from "@/shared/i18n/locale-cookie";
import { LocaleProvider } from "@/shared/i18n/LocaleProvider";
import { ErrorBoundary } from "@/shared/ui/ErrorBoundary";
import { applyStoredTheme } from "@/shared/ui/theme";
import { installChunkReload } from "@/app/errors/chunk-reload";
import { RootErrorFallback } from "@/app/errors/RootErrorFallback";
import { NewVersionBar } from "@/app/version/NewVersionBar";
import { router } from "@/router";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("#root is missing from index.html");

applyStoredTheme();
installChunkReload();

const locale = readLocaleCookie() ?? DEFAULT_LOCALE;
const dictionary = await loadDictionary(locale).catch(() => loadDictionary(DEFAULT_LOCALE));

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary fallback={RootErrorFallback}>
      <LocaleProvider initialLocale={locale} initialDictionary={dictionary}>
        <NewVersionBar enabled={import.meta.env.PROD} />
        <RouterProvider router={router} />
      </LocaleProvider>
    </ErrorBoundary>
  </StrictMode>,
);
